export const getLatestDocument = (documents) => {
    return documents.reduce((carry, document) => {
        return carry && carry.createdAt.localeCompare(document.createdAt) > 0 ? carry : document;
    }, null);
};
